"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBedSchema = exports.createBedSchema = exports.bedShape = exports.isolationTypeEnum = exports.bedStatusEnum = exports.bedTypeEnum = void 0;
const zod_1 = require("zod");
// Hospital Infrastructure — Bed Master. `bedCode` and `wardId` are
// server-derived (from `roomId`) and deliberately not part of the
// create/update input shape.
exports.bedTypeEnum = zod_1.z.enum([
    'GENERAL',
    'ICU',
    'NICU',
    'PICU',
    'SICU',
    'PRIVATE',
    'DELUXE',
    'SUITE',
]);
exports.bedStatusEnum = zod_1.z.enum([
    'AVAILABLE',
    'OCCUPIED',
    'BLOCKED',
    'UNDER_CLEANING',
    'MAINTENANCE',
    'RESERVED',
    'TRANSFER_PENDING',
    'DISCHARGE_PENDING',
]);
exports.isolationTypeEnum = zod_1.z.enum([
    'NONE',
    'AIRBORNE',
    'DROPLET',
    'CONTACT',
    'PROTECTIVE',
    'NEGATIVE_PRESSURE',
    'POSITIVE_PRESSURE',
]);
exports.bedShape = {
    roomId: zod_1.z.string().uuid(),
    bedNumber: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().max(150).nullable().optional(),
    type: exports.bedTypeEnum,
    status: exports.bedStatusEnum.optional(),
    chargeCategoryId: zod_1.z.string().uuid().nullable().optional(),
    isolationType: exports.isolationTypeEnum.optional(),
    hasOxygen: zod_1.z.boolean().optional(),
    hasVentilator: zod_1.z.boolean().optional(),
    hasMonitor: zod_1.z.boolean().optional(),
    isElectricBed: zod_1.z.boolean().optional(),
    side: zod_1.z.string().max(20).nullable().optional(),
    isWindowSide: zod_1.z.boolean().optional(),
    isNearNurseStation: zod_1.z.boolean().optional(),
    lastCleanedAt: zod_1.z.coerce.date().nullable().optional(),
    cleaningRequired: zod_1.z.boolean().optional(),
    cleaningStaffId: zod_1.z.string().uuid().nullable().optional(),
    reservedUntil: zod_1.z.coerce.date().nullable().optional(),
    reservedById: zod_1.z.string().uuid().nullable().optional(),
    reservationReason: zod_1.z.string().nullable().optional(),
    maintenanceRequired: zod_1.z.boolean().optional(),
    maintenanceCategory: zod_1.z.string().max(100).nullable().optional(),
    maintenanceDate: zod_1.z.coerce.date().nullable().optional(),
    maintenanceRemarks: zod_1.z.string().nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createBedSchema = zod_1.z.object(exports.bedShape);
exports.updateBedSchema = exports.createBedSchema.partial();
//# sourceMappingURL=bed.schema.js.map